import React from "react"
import PropTypes from "prop-types"
import { Dialog } from "@tencent/spaui"

class DockedDialog extends React.PureComponent {
  static propTypes = {
    position: PropTypes.string,
    hideHeader: PropTypes.bool,
    className: PropTypes.string,
  }

  render() {
    const { position, hideHeader, className, ...props } = this.props
    return (
      <Dialog
        position={position || "right"}
        animation={false}
        hideHeader={hideHeader === undefined ? true : hideHeader}
        // modalClassName='no-cover'
        className={`${className} DockedDialog with-full-height`}
        {...props}
      />
    )
  }
}

export default DockedDialog
